import React from "react";
import { Box, Typography, Divider, Stack } from "@mui/material";
import EditableOrderItemCard from "./EditableOrderItemCard";

const EditableOrderItemList = ({
  order,
  setOrder,
  flavorOptions,
  sizeOptions,
}) => {
  const handleItemUpdate = (index, updatedItem) => {
    const newItems = [...order.items];
    newItems[index] = updatedItem;
    setOrder({ ...order, items: newItems });
  };

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom>
        Order Items
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Stack spacing={2}>
        {order.items.map((item, index) => (
          <EditableOrderItemCard
            key={index}
            item={item}
            index={index}
            onItemChange={(updatedItem) => handleItemUpdate(index, updatedItem)}
            flavorOptions={flavorOptions}
            sizeOptions={sizeOptions}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default EditableOrderItemList;
